module.exports = __webpack_public_path__ + "img/24ne.bb455126.svg";